import MechanicalTask from "./MechanicalTask";

export default MechanicalTask;